import React from 'react';
import { Typography, useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

// STYLES
import { Container } from './styles';

const Hero = () => {
  const [t] = useTranslation();
  const upXs = useMediaQuery(({ breakpoints }) => breakpoints.up('sm'));

  return (
    <Container className="hero">
      <div className="hero__wrapper">
        <div className="page-content hero__page-content">
          {upXs && (
            <Typography
              className="hero__subtitle subtitle-secondary"
              variant="inherit"
              color="inherit"
              component="p"
              align="center"
            >
              {t('home.heroNonAuth.subtitle')}
            </Typography>
          )}
          <Typography className="hero__title" variant="h2" color="inherit" align="center">
            {t('home.heroNonAuth.title')}
          </Typography>
        </div>
      </div>
    </Container>
  );
};
export default Hero;
